import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import Constants from "../../helpers/Constants";

// 우진 (2026-09-09): 활용백서(/playbook) 전용 GNB — Figma 1545:19689 (1920×74).
// 일반 Navbar(230:17234)와 bar/brand/logo/btn/cta 클래스를 그대로 공유하고,
// 항목만 교체한다: 로고 · '활용백서' · '그로잉세일즈 홈 ↗'  |  '로그인'(pill).
// 메가 메뉴 / over-dark / 모바일 드로어 없음. 델타 스타일은
// scss/playbook/_nav.scss 의 .gnb--playbook 에만 둔다 (_navbar.scss 미수정).
import logoNavy from "../../img/landing/logo_growingsales.svg";

// Figma I1545:19689;225:16620;243:21334 — 20×20 arrow-up-right, stroke
// currentColor(#16191D) 2px round caps. Navbar.js 의 Icon("arrow-up-right")
// 와 동일 glyph.
function ArrowUpRight() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M7 17L17 7M8 7h9v9" />
    </svg>
  );
}

// Figma Nav(left) I1545:19689;105:50 — row gap 8. 라우트는 Figma 에 없음
// (suspect: S5 — '활용백서' → /playbook, '그로잉세일즈 홈' → "/" 로 가정).
const LEFT_NAV = [
  { key: "playbook", label: "활용백서", to: "/playbook" },
  { key: "home", label: "그로잉세일즈 홈", to: "/", chevron: true },
];

export default function PlaybookNav() {
  const [scrolled, setScrolled] = useState(false);

  // suspect: S3 blur/scroll state not in Figma — Figma 는 transparent bar +
  // BACKGROUND_BLUR 20 만 정의. Navbar.js 와 동일하게 scroll > 8 에서
  // .gnb--scrolled (translucent paper + $blur-gnb) 로 전환하는 기존 동작 유지.
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const classList = [
    "gnb",
    "gnb--playbook",
    scrolled ? "gnb--scrolled" : "gnb--default",
  ].join(" ");

  return (
    <header className={classList}>
      <div className="gnb__bar">
        <div className="gnb__bar-inner">
          {/* logo 260:30774 — 32×32 navy/yellow mark, no wordmark */}
          <Link to="/" className="gnb__brand">
            <span className="gnb__logo" aria-label="GrowingSales">
              <img
                className="gnb__logo-mark"
                src={logoNavy}
                alt=""
                aria-hidden="true"
                width="32"
                height="32"
              />
            </span>
          </Link>

          {/* suspect: S8 mobile not in Figma — 드로어 없음. 모바일에서는 base
              Navbar 규칙대로 좌측 클러스터는 숨기고(로고가 "/" 링크 역할)
              우측 '로그인' pill 만 유지해 bar 를 60px 로 고정 (_nav.scss). */}
          <nav className="gnb__nav gnb__nav--left" aria-label="주요 네비게이션">
            {LEFT_NAV.map((n) => (
              <div key={n.key} className="gnb__btn-wrap">
                <Link
                  to={n.to}
                  className={n.chevron ? "gnb__btn gnb__btn--gap-6" : "gnb__btn"}
                >
                  <span>{n.label}</span>
                  {n.chevron && (
                    <span className="gnb__chevron">
                      <ArrowUpRight />
                    </span>
                  )}
                </Link>
              </div>
            ))}
          </nav>

          {/* Nav(right) I1545:19689;195:15075 — single CTA pill '로그인'
              (I…;225:16555). 대상은 기존 Navbar 와 동일하게 대시보드(외부). */}
          <nav className="gnb__nav gnb__nav--right" aria-label="계정">
            <a
              href={Constants.DASHBOARD_HOME}
              target="_blank"
              rel="noopener noreferrer"
              className="gnb__cta"
            >
              로그인
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
}
